import PackageSearchStore from './PackageSearchStore';
import BestPriceAvailabilitySearchStore from '../BestPriceAvailabilitySearch/BestPriceAvailabilitySearchStore';
import dayjs from 'dayjs';

export const isSearchDisabled = (a: {
  store: PackageSearchStore | BestPriceAvailabilitySearchStore;
  destinationMandatory?: boolean;
  endDateMandatory?: boolean;
  withCategorySelect?: boolean;
  hideOrigin?: boolean;
  originMustBeSet?: boolean;
  mainServiceCodes?: string[];
}): boolean => {
  const {
    store,
    destinationMandatory,
    endDateMandatory,
    withCategorySelect,
    hideOrigin,
    mainServiceCodes,
    originMustBeSet
  } = a;

  const { startDate, duration: durationValue, destinations } = store.searchParams;

  const duration = Number(durationValue);

  const hasValidStartDate = Boolean(startDate) && dayjs(startDate).isValid();

  const hasValidDuration = durationValue !== undefined && Number.isFinite(duration) && duration > 0;

  const originsLogic =
    originMustBeSet && !(mainServiceCodes && mainServiceCodes.length) // When we have hotel codes (The origins are no longer mandatory).
      ? store.origins && store.origins.length > 0
      : true;
  const destinationLogic = !(mainServiceCodes && mainServiceCodes.length) // When we have hotel codes (The destination are no longer mandatory).
    ? store.destination?.code || store.partialSearchParams.destinationItem
    : true;

  return (
    !(
      //THG
      (
        (!hideOrigin &&
          destinationMandatory &&
          endDateMandatory &&
          store.searchParams.endDate !== 'Invalid Date' &&
          (store.origin?.code || originsLogic) &&
          destinationLogic) ||
        //VOM
        hideOrigin ||
        withCategorySelect ||
        //YSN...
        ((destinations?.length ?? 0) > 0 && hasValidDuration && hasValidStartDate)
      )
    ) ||
    !!(
      store instanceof PackageSearchStore &&
      store?.validationErrorMessages &&
      store?.validationErrorMessages?.length > 0
    )
  );
};

export default isSearchDisabled;
